import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import Box from "@mui/material/Box";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import { StoreContext } from "../../../../../../store/StoreProvider";
import ColorCirclePopup from "../../../../../../common/components/popup/ColorCirclePopup";
//
import Act from "../../../../../../store/actions";
import urls from "../../../../../../api/project/ApiUrls";
//
import { forwardTransColor, reversTransColor } from "../utils";

const AccordionDetailChildren = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group } = user;
  const { adjust } = sna;
  // local state
  const [userColors, setUserColors] = useState(
    forwardTransColor(adjust?.linkColors?.change || [])
  );
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const handleColorChange = (color, event) => {
    // console.log("handleColorChange color", color);
  };

  /**
   * color:
   * @param color
   * color = {hex: '#333',rgb: {r: 51,g: 51,b: 51,a: 1,},hsl: {h: 0,s: 0,l: .20,a: 1,},}
   *
   * @param event
   * @param colors: 目前已變更的所有 colors
   */
  const handleColorChangeComplete = (color, event, colors) => {
    // setUserColors(colors);
  };

  const handleColorFocus = (colorIdx, colorProps) => {};

  /**
   * 當選取完成後, 儲存結果
   * @param colors: 目前已變更的所有 colors
   */
  const handleFinish = (colors) => {
    setUserColors(colors);
    dispatch({
      type: Act.SNA_ADJUST_LINK_COLORS_CHANGE,
      payload: reversTransColor(colors),
    });
    // todo: 儲存變更至 firebase
  };

  return (
    <Box>
      <ColorCirclePopup
        variant="grey"
        onColorFocus={handleColorFocus}
        colorPickerProps={{
          width: "156px",
          className: "color-picker",
          onChange: handleColorChange,
          onChangeComplete: handleColorChangeComplete,
        }}
        onFinish={handleFinish}
        colors={userColors}
        colorBoxProps={{ sx: { width: "160px" } }}
        popoverProps={{}}
      />
    </Box>
  );
};

export default AccordionDetailChildren;
